import {useMutation, useQuery, useQueryClient, UseQueryResult} from "react-query";
import {getNewsByParams, PostNewNews, PutNewNews, PutOrdreNews, TrashNews} from "./news.services";
import {useUserConnected} from "../../services/hooks";
import {toast} from "react-toastify";



export const useGetNewsByParams = (params:any|null|undefined, CentreId:number|null=null):UseQueryResult<News[], Error>=>{
    const userConnected:{ userConnected: UserSimple | undefined } = useUserConnected();
    if(!CentreId) {
        CentreId = (userConnected === undefined || userConnected.userConnected === undefined) ? null : userConnected.userConnected.Centre.id;
    }
    const myParams:any = params === undefined || params === null ? {Centre:CentreId} : {...params, Centre:CentreId}
    return useQuery<News[], Error>(["news", params, CentreId], ()=>getNewsByParams(myParams), {
        staleTime:5000,
        enabled:params!==undefined && CentreId!==undefined
    })
}

export const useAddNews = (idCentre:number|null=null)=>{
    const queryClient = useQueryClient();
    const userConnected:{ userConnected: UserSimple | undefined } = useUserConnected();
    const UserStr =userConnected && userConnected.userConnected ?   `api/users/${userConnected.userConnected.id}` : '';
    let CentreStr = userConnected && userConnected.userConnected ? `api/centres/${userConnected.userConnected.Centre.id}` : '';
    if(idCentre) {
       CentreStr =  `api/centres/${idCentre}`
    }
    return useMutation(
        (data:NewsFD) => {
            data.Centre = CentreStr;
            data.UserCreate = UserStr;
            return PostNewNews(data);
        },
        {
            onSuccess: (newData) => {
                queryClient.invalidateQueries(["news"]);
                toast.success("News crée !", {});
            },
            onError: (error: any) => {
                toast.error("Erreur : " + error.message, {});
            },
        }
    );
}

export const useModifyNews = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data:NewsFD) => {
            return PutNewNews(data);
        },
        {
            onSuccess: (newData) => {
                queryClient.invalidateQueries(["news"]);
                toast.success("News modifiée !", {});
            },
            onError: (error: any) => {
                toast.error("Erreur : " + error.message, {});
            },
        }
    );
}

export const useModifyOrdreNews = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (data: { id:number, ordreAffichage:number }) => {
            return PutOrdreNews(data);
        },
        {
            onSuccess: () => {
                queryClient.invalidateQueries(["news"]);
            }
        }
    );
}

export const useTrashNews = ()=>{
    const queryClient = useQueryClient();
    return useMutation(
        (id:number) => {
            return TrashNews(id);
        },
        {
            onSuccess: (newData) => {
                queryClient.invalidateQueries(["news"]);
                toast.success("News supprimée !", {});
            },
            onError: (error: any) => {
                toast.error("Erreur : " + error.message, {});
            },
        }
    );
}